import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';

const drawerWidth = 250;

const useStyles = makeStyles(theme => ({ 
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
      },
      drawerPaper: {
        width: drawerWidth,
      },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    })
)

const SideBar = ({ open, drawerWidth, children }) => {
    const classes = useStyles();

    return (
        <Drawer
        className={classes.drawer}
        drawerWidth={drawerWidth}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
        paper: classes.drawerPaper,
        }}
    >
        { children } 
    </Drawer>
    )
}

export default SideBar